module.exports = __webpack_public_path__ + "img/polucion.a924e2c7.svg";